export default __webpack_public_path__ + "static/biz-advice-right-950339f5f61fd1432289f4f9fcebc6fc.svg";